import { render } from "./ResetPwd.vue?vue&type=template&id=68e604bb"
import script from "./ResetPwd.vue?vue&type=script&lang=js"
export * from "./ResetPwd.vue?vue&type=script&lang=js"

import "./ResetPwd.vue?vue&type=style&index=0&id=68e604bb&lang=css"

import exportComponent from "/var/jenkins_home/workspace/aws.dot-account-site.US/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__